import React from 'react'
import { Notification } from './elements'

interface FormNotificationProps {
    error?: string
    message?: string
    errormessage?: string
    successmessage?: string
    style?: Object
}
const FormNotification = ({
    error,
    message,
    errormessage,
    successmessage,
    style,
}: FormNotificationProps) => {
    const condition = !!error || !!message || !!errormessage || !!successmessage
    const text = error || message || errormessage || successmessage

    return (
        <Notification
            data-cy="notification"
            className="animated fadeIn td-100"
            style={style}
            error={condition}
            message={message}
            errormessage={errormessage}
            successmessage={successmessage}
        >
            {text}
        </Notification>
    )
}

FormNotification.defaultProps = {
    error: '',
    message: '',
    errormessage: '',
    successmessage: '',
}
export default FormNotification
